module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-2.34b50890.jpeg";